const state = {
    pwaVersion: null,
    updateAvailable: false,    
    isNotificationEnabled:false,
    appLoading:false,
    isOffline: !navigator.onLine,
    pushNotification: {
        state: 'prompt', // Default to 'prompt'
        icon: 'mdi-alert-octagon',
        color: '', // Determined by the state
    },
    location: {
        state: 'prompt', // Default to 'prompt'
        icon: '',
        color: '', // Determined by the state
    },
    apiConfigs: {
    skymat: {
        baseURL: 'https://skymatfactsapi.ngrok.io',
        headers: {
            Company: 'Skymat'
        }
    },
    triton: {
        baseURL: 'https://tritonfactsapi.ngrok.io',
        headers: {
            Company: 'Triton'
        }
    }
    }
}

const getters ={
    getAPIConfig: (state) => (apiName) => {
        return state.apiConfigs[apiName];
    },
    updateAvailable: (state) => state.updateAvailable,
    isNotificationEnabled: (state) => state.isNotificationEnabled,
    pushNotificationPermission: (state) => state.pushNotification,
    locationPermission: (state) => state.location,
}
// Helper function to determine color by permission state
function getColorByPermissionState(permissionState) {
    return permissionState === 'granted' ? 'green' : permissionState === 'denied' ? 'red' : ''; // No color for 'prompt'
  }

const mutations ={
    SET_UPDATE_AVAILABLE(state, payload) {
        state.updateAvailable = payload;
    },
    SWITCH_NOTIFICATION(state){
        state.isNotificationEnabled=!state.isNotificationEnabled
    },
    SET_APP_LOADING(state, payload) {
        state.appLoading = payload;
    },
    SET_OFFLINE(state, payload) {
        state.isOffline = payload;
    },
    SET_NOTIFICATION_ENABLED(state, isEnabled) {
        state.isNotificationEnabled = isEnabled;
    },
    SET_PUSH_NOTIFICATION_STATE(state, permissionState) {
        state.pushNotification.state = permissionState;
        state.pushNotification.color = getColorByPermissionState(permissionState);
    },
    SET_LOCATION_STATE(state, permissionState) {
        state.location.state = permissionState;
        state.location.color = getColorByPermissionState(permissionState);
        state.location.icon  = permissionState !=='denied'? "mdi-map-marker" : "mdi-map-marker-off-outline";
    },

}

const actions = {
    appUpdate({commit}, payload){
        commit('SET_UPDATE_AVAILABLE',payload);
    },    
    toggleNotification({ state,commit,dispatch }) {
        if(!state.isNotificationEnabled){
            // dispatch('requestNotificationPermission')
            dispatch('requestNotificationPermission', null, { root: true });
        }       
        commit('SWITCH_NOTIFICATION');
        dispatch('checkPushNotificationPermission'); 
    },
    appLoading({commit}, payload){
        commit('SET_APP_LOADING',payload);
    },
    appOffline({commit}, payload){
        commit('SET_OFFLINE',payload);
    },
    appNotificationEnabled({commit},payload){
        commit('SET_NOTIFICATION_ENABLED',payload)
    },
    checkPushNotificationPermission({ commit }) {
        navigator.permissions.query({ name: 'notifications' }).then((result) => {
            commit('SET_PUSH_NOTIFICATION_STATE', result.state);
        });
    },
    checkLocationPermission({ commit }) {
        navigator.permissions.query({ name: 'geolocation' }).then((result) => {
            commit('SET_LOCATION_STATE', result.state);
        });
    },
}

export default {
    namespace: true,
    state,
    getters,
    mutations,
    actions,
  };
  